import { Grid, useTheme } from "@mui/material";
import { PageContainer } from "core";
import React from "react";
import HelpPage from "sections/help/HelpContent";

export default function Help({ title }) {
  const theme = useTheme();
  return (
    <PageContainer title={title}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HelpPage theme={theme} />
        </Grid>
      </Grid>
    </PageContainer>
  );
}
